import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/apiClient";
import AuthShell from "@/components/layout/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const account = await register(name, email, password);
      if (account?.verification_email_sent === false) toast.warning("Account created. Email delivery failed; request another verification email in Settings.");
      else toast.success("Account created — check your inbox to verify your email");
      navigate("/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Registration failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create account"
      subtitle="Start integrating live media in minutes."
      footer={<>Already have an account? <Link to="/login" className="text-zinc-200 underline underline-offset-4" data-testid="link-login">Sign in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label htmlFor="name" className="text-zinc-300">Name</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)}
            data-testid="register-name" className="bg-zinc-950 border-zinc-800" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email" className="text-zinc-300">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email" className="bg-zinc-950 border-zinc-800" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password" className="text-zinc-300">Password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password" className="bg-zinc-950 border-zinc-800" minLength={8} required />
          <p className="text-xs text-zinc-500">At least 8 characters.</p>
        </div>
        <Button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-zinc-50 text-zinc-900 hover:bg-zinc-200">
          {loading ? "Creating…" : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
